// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback textarea.form-control.randomized[data-v-be7d6312] {\n  width: 93% !important;\n}\n", ""]);
// Exports
module.exports = exports;
